module.exports = __webpack_public_path__ + "static/media/featured-signup.3489147f.jpg";